export const checksums = {
  "content": "v3.5.0--82ukKd8kK4CVtzgkjQwrSdkx8v05tLCeXc7rgX0CSbY",
  "investigation": "v3.5.0--fPH_2iKf4znR2fn2q0SXFk50NI8EPlsvD9WmZNy6uug",
  "investigationChapter": "v3.5.0--7iTlv6R5K0yU7UQRh4rXpiPsLC1nfzF01c3XYZhJagw",
  "animal": "v3.5.0--J0CFoiOh0IXmKlKteCp2byPNtT1vaWgl_H4KCiwo7XA",
  "annotation": "v3.5.0--XWWhspS7LjzI34o7JMO7urxIq5-yivBVk5qNQxddBu0",
  "welfareBrand": "v3.5.0--TcRESr25OGP7eza3A_GihR2c0MYydP4xfpdYwhtUUSM",
  "location": "v3.5.0--O6XmIkRzThBx9dzPc7hOYV7tGGBGuI7ma9I0ynRqX-o"
}
export const checksumsStructure = {
  "content": "00hiqyhvKslj6iTap5B_V01P71a7jy5pCr0uV_J8xIQ",
  "investigation": "xA4F3o0rhEmbNHNgOC9DqvmMyfsHcTMp5lHw5WfSU0M",
  "investigationChapter": "6pgfK949Tk7GXetgNMdL_J3qQXllLS7stWoLx-v5IBA",
  "animal": "QOvx9-_tHofwOeDchew66z6q3P39bXhDFoRRRFAaN-8",
  "annotation": "z9TNlTwcV6gg6SFKENAot4KYZhYLz-Q3yPuwjG8XalA",
  "welfareBrand": "-1hj4EUcUPXFqhQrEAvKr0-2WuAZrOlWTnC5Q9WibhA",
  "location": "xr7DBJXxadRgaYfFEXJcjNPSYsdMIF2-txuvxLHsq7o"
}

export const tables = {
  "content": "_content_content",
  "investigation": "_content_investigation",
  "investigationChapter": "_content_investigationChapter",
  "animal": "_content_animal",
  "annotation": "_content_annotation",
  "welfareBrand": "_content_welfareBrand",
  "location": "_content_location",
  "info": "_content_info"
}

export default {
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "head": "json",
      "schemaOrg": "json",
      "image": "json"
    }
  },
  "investigation": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "head": "json",
      "schemaOrg": "json",
      "animals": "json",
      "video": "string",
      "image": "json",
      "date": "date",
      "published": "boolean"
    }
  },
  "investigationChapter": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "head": "json",
      "schemaOrg": "json",
      "image": "json"
    }
  },
  "animal": {
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "plural": "string",
      "slug": "string",
      "icon": "string",
      "key": "string"
    }
  },
  "annotation": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json"
    }
  },
  "welfareBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "label": "string",
      "subLabel": "string",
      "key": "string"
    }
  },
  "location": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "head": "json",
      "schemaOrg": "json",
      "position": "json",
      "address": "json",
      "video": "string",
      "animals": "json",
      "welfareBrandKey": "string",
      "owner": "string",
      "organization": "string",
      "stableSystem": "string",
      "companyName": "string",
      "visible": "boolean"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}